import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {useState} from "react";
import {initialResourceItemCount} from "../utils/helpers";
import {ReplacementPartsModel} from "../models/view/replacementPartsModel";

export const useReplacementPartsQuery = () => {
    const {model: {replacementParts: crossSells}} = useProductDetailsQuery();
    const [showCount, setShowCount] = useState<number>(initialResourceItemCount);
    const {replacementParts, hasReplacementParts, count} = new ReplacementPartsModel(crossSells);
    return {
        model: {
            replacementParts: replacementParts.slice(0, showCount),
            breakOutEarly: !hasReplacementParts,
            moreToShow: count > showCount,
            showAll: () => setShowCount(count)
        }
    };
}